import { Outlet } from 'react-router-dom';

/** 헤더/푸터 없이 본문만 렌더링하는 라우트 레이아웃 (예: PG사 결제 콜백 페이지) */
export const BareLayout = () => {
  return (
    <>
      <main>
        <Outlet />
      </main>
    </>
  );
};
